var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/back-to-catalog.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.backToCatalogData.backToCatalogUrl"]));
frame.set("backToCatalogUrl", t_1, true);
if(frame.topLevel) {
context.setVariable("backToCatalogUrl", t_1);
}
if(frame.topLevel) {
context.addExport("backToCatalogUrl", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.backToCatalogData.pageName"]));
frame.set("backToCatalogPageName", t_2, true);
if(frame.topLevel) {
context.setVariable("backToCatalogPageName", t_2);
}
if(frame.topLevel) {
context.addExport("backToCatalogPageName", t_2);
}
output += "\n\n<li class=\"dom-back-to-catalog c-breadcrumb__li s-return-to-search-breadcrumb";
if(!runtime.contextOrFrameLookup(context, frame, "backToCatalogUrl")) {
output += " is-hidden";
;
}
output += "\">\n";
if(runtime.contextOrFrameLookup(context, frame, "backToCatalogUrl") && runtime.contextOrFrameLookup(context, frame, "backToCatalogPageName")) {
output += "\n    <a class=\"c-breadcrumb__a\" href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "backToCatalogUrl"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((lineno = 5, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"analytics")),"productTypeSlug"),"return to search"])), env.opts.autoescape);
output += " data-qa-back-to-search>\n        <span itemprop=\"name\">";
output += runtime.suppressValue((lineno = 6, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["pdp_back_to_results"])), env.opts.autoescape);
output += " \"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "backToCatalogPageName"), env.opts.autoescape);
output += "\"</span>\n    </a>\n";
;
}
output += "\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/back-to-catalog.j2"] , dependencies)